import { useState, useEffect } from "react";
import axios from "axios";
import pixelEvent from "./pixelEvent";

export default function useMakeRequest() {
  const url =
    process.env.NODE_ENV === "development"
      ? "http://pcappstore.loc/api/api.php"
      : "/api/api.php";

  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [result, setReult] = useState(null);

  useEffect(() => {
    if (params === null || params === undefined || params === "") {
      return;
    }
    setIsLoading(true);
    axios({
      method: "post",
      url,
      data: params,
    })
      .then((response) => {
        if (response.data.state === "error") {
          setHasError(true);
          setError(
            response.data.result !== ""
              ? response.data.result
              : "Something went wrong. Reload the page or visit later"
          );
          pixelEvent({
            evt_src: "acct",
            evt_action: "show_error",
            message: response.data.result,
          });
          setIsLoading(false);
        } else {
          setHasError(false);
          setError("");
          setReult(response.data.result);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        pixelEvent({
          evt_src: "acct",
          evt_action: "show_error",
          messsage: err.message,
        });
        setHasError(true);
        setError("Something went wrong. Reload the page or visit later");
        setIsLoading(false);
      });
  }, [params]);

  return [setParams, result, isLoading, hasError, error];
}

/* HOW TO USE THIS
 
 const [setParams, result, isLoading, hasError, error] = useMakeRequest();

  useEffect(() => {
    setParams({
      c: "front",
      a: "faOfferConfig",
    });
  }, []);

 */

/* Convenient console output 

console.log(
  "isLoading:",
  isLoading,
  "| data:",
  data,
  "| hasError:",
  hasError,
  "| error:",
  error,
  "| STATE error:",
  emailError
);

*/
